import { BaseQueryParams } from "../baseQuery";

export const reportsService = BaseQueryParams("reportsService", [
  "ADMIN_REPORTS",
  "DEBUG_STAT",
]).injectEndpoints({
  endpoints: (builder) => ({
    getReportService: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/service?${page ? `page=${page}` : ""}&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
      providesTags: () => ["ADMIN_ACCOUNTS"],
    }),

    getServiceCharts: builder.query({
      query: ({ body }) => ({
        url: `/admin/reports/service/chart`,
        method: "GET",
        params: body,
      }),

      keepUnusedDataFor: 0,
    }),

    getMigrationsLogs: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/migrations/logs?${page ? `page=${page}` : ""}&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getCouponsList: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/migrations/coupons?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getWizardStats: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/migrations/wizard-statistics?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportRatesTotal: builder.query({
      query: ({ filters }) => ({
        url: `/admin/reports/migrations/rates/totals`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportRates: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/migrations/rates?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportProxies: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/migrations/proxies?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportRemigrations: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/migrations/remigrations-statistics?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportStepsFunnel: builder.query({
      query: ({ filters }) => ({
        url: `/admin/reports/migrations/steps-funnel`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportTicketsSurvey: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/survey-tickets?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
    }),

    getReportDebugStatistics: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/reports/migrations/debug-statistics?${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
      providesTags: () => ["DEBUG_STAT"],
    }),

    deleteDebugStat: builder.mutation({
      query: (id) => ({
        url: `/admin/reports/migrations/debug-statistics/${id}`,
        method: "Delete",
      }),

      invalidatesTags: () => ["DEBUG_STAT"],
    }),
  }),
});

export const {
  useGetReportServiceQuery,
  useGetServiceChartsQuery,
  useGetMigrationsLogsQuery,
  useGetCouponsListQuery,
  useGetReportRatesQuery,
  useGetReportRatesTotalQuery,
  useGetWizardStatsQuery,
  useGetReportProxiesQuery,
  useGetReportRemigrationsQuery,
  useGetReportStepsFunnelQuery,
  useGetReportTicketsSurveyQuery,
  useGetReportDebugStatisticsQuery,
  useDeleteDebugStatMutation,
} = reportsService;
